import { render, staticRenderFns } from "./company_list.vue?vue&type=template&id=1a1e275e&scoped=true&"
import script from "./company_list.vue?vue&type=script&lang=js&"
export * from "./company_list.vue?vue&type=script&lang=js&"
import style0 from "./company_list.vue?vue&type=style&index=0&id=1a1e275e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e275e",
  null
  
)

export default component.exports